import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { MessageService } from 'src/app/@shared/message/message.service';
import { api } from 'src/app/@shared/services/api';
import { CommonService } from 'src/app/@shared/services/common.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-user-create',
  templateUrl: './user-create.component.html',
  styleUrls: ['./user-create.component.css']
})
export class UserCreateComponent implements OnInit {
  public api = api;
  public env = environment;
  private subs: Subscription[] = [];
  public data: any;
  public resData: any;
  private uId: any;
  public key: any;
  formData!: FormGroup;
  submitted = false;
  submit = false;
  user: any = {};
  public eventTypes: any[] = [];
  public partnerShip: any = {};
  pa: any;

  constructor(public service: WebserviceService,
    public actRoute: ActivatedRoute,
    private _common: CommonService,
    private _message: MessageService,
    private fb: FormBuilder) {
    this.eventTypes = (localStorage.getItem(`${this.env.panel}menu`)) ? JSON.parse(localStorage.getItem(`${this.env.panel}menu`) as any) : [];
  }

  ngOnInit(): void {
    this.uId = this.actRoute.snapshot.paramMap.get('uid');
    this.key = this.actRoute.snapshot.paramMap.get('key');

    let pointAcc = (localStorage.getItem(`${this.env.panel}pointAcc`)) ? JSON.parse(localStorage.getItem(`${this.env.panel}pointAcc`) as any) : '';
    this.pa = (pointAcc && this.actRoute.snapshot.paramMap.get('key') == 'client') ? true : false;

    this.user = (localStorage.getItem(`${this.env.panel}user`)) ? JSON.parse(localStorage.getItem(`${this.env.panel}user`) as any) : '';
    let role_id: any;
    this.env.userList.forEach(element => {
      if (this.key == element.id) { role_id = element.role_id }
    });
    this.formData = this.fb.group({
      role_id: [role_id],
      name: ['', Validators.required],
      username: ['', Validators.required],
      password: ['', Validators.required],
      password_confirmation: ['', Validators.required],
      free_chip: [0, Validators.required],
      domain: [this.env.domain],
      error: [""],
    }, {
      validator: [
        this._common.mustMatch('password', 'password_confirmation'),
        this._common.checkUserAvail("username", "error"),
      ],
      // validator: this._common.mustMatch('password', 'password_confirmation'),
    });

    // if (this.pa == true) {
    //   this.formData.removeControl('free_chip');
    // }
    this.onValueChanges();
    this.getData();
  }

  onValueChanges(): void {
    this.formData.valueChanges.subscribe(val => {
      this.onChangeChip()
    })
  }

  getServices(): IbaseService<any> {
    return this.service;
  }

  get f() {
    return this.formData.controls;
  }

  getData() {
    const sub1 = this.getServices().Get(`${this.env.baseUrl + this.api.user}/${this.actRoute.snapshot.paramMap.get('uid') + this.api.getCreateUser}/${this.actRoute.snapshot.paramMap.get('key')}`).subscribe(
      (res) => {
        if (res.status == true) {
          // res.data.statement.data = this._common.UTC_to_Local_timeZone(res.data.statement.data);
          this.data = res.data;
          this.data.user['remainBal'] = parseFloat(res?.data?.user?.available_balance)

          this.eventTypes.forEach((element, i) => {
            if(element.name.toLowerCase().includes('kabaddi')) {
              this.env.hidePartenerShips.push(element.id)
            }
          });
          
          let prt: any = {};
          this.eventTypes.forEach((element, i) => {
            if (element.id != 99994) {
              if (!this.env.hidePartenerShips.includes(element.id)) {
                prt[element.id] = { 'availablePrt': res?.data?.partnership[element.id], 'downlinePrt': 0, 'myPrt': res?.data?.partnership[element.id] };
              }
            } 
          });
          this.partnerShip = prt;
          // console.log(this.partnerShip);


          // if (this.data?.parent?.id != this.user?.id) {
          //   this.formData.controls['parent_password'].setValidators([Validators.required]);
          // } else {
          //   this.formData.controls['parent_password'].clearValidators();
          // }
          // this.formData.controls['parent_password'].updateValueAndValidity();
        } else {
          this._common.checkForForceChangePassword(res);
        }
      },
      (err) => {
        console.log(err);
      });
    this.subs.push(sub1)
  }

  onChanePrt(e: any) {
    if (this.partnerShip[e.id].downlinePrt <= this.partnerShip[e.id].availablePrt) {
      this.partnerShip[e.id].myPrt = parseInt(this.partnerShip[e.id].availablePrt) - parseInt(this.partnerShip[e.id].downlinePrt);
    } else {
      this.partnerShip[e.id].downlinePrt = 0;
      this.partnerShip[e.id].myPrt = this.partnerShip[e.id].availablePrt;
    }
  }

  onChangeChip() {
    if (this.data?.user)
      this.data.user.remainBal = parseFloat(this.data.user.available_balance) - parseFloat(this.formData.value.free_chip);
  }

  remainBal() {
    return (Number(this.data?.user?.available_balance) - Number(this.formData.value.withdraw_chips))
  }

  checkUserAvailability(e: any) {
    if (this.f.username.value.length >= 1) {
      this.getServices().Get(`${this.env.baseUrl + this.api.user}/${this.actRoute.snapshot.paramMap.get('uid') + this.api.checkUsername}/${this.f.username.value}`).subscribe((res: any) => {
        if (res?.data?.status == true) {
          this.formData.patchValue({
            error: "",
          });
        } else if (res?.data?.status == false) {
          this.formData.patchValue({
            error: res?.data?.message,
          });
        }
        console.log(this.formData.value);

      },
        (err) => {
          console.log(err);
        }
      );
    }
  }

  onSubmit() {

    this.submitted = true;


    let req = this.formData.value;
    let prt: any = {};
    let isInValid: boolean = false;
    this.eventTypes.forEach(element => {
      if (!this.env.hidePartenerShips.includes(element.id)) {
        if (this.partnerShip[element.id].downlinePrt === null || this.partnerShip[element.id].downlinePrt === '' && isInValid == false) {
          // stop here if partner-sheep is blank
          isInValid = true;
        } else {
          prt[element.id] = this.partnerShip[element.id].downlinePrt;
        }
        // console.log(isInValid);

      }
    });

    if (this.actRoute.snapshot.paramMap.get('key') != 'client')
      req["partnerships"] = prt;

    // console.log(req); return

    // stop here if form is invalid
    if (this.formData.invalid || isInValid != false) {
      return;
    }
    this.submit = true;
    delete req.error;

    const sub2 = this.getServices().Post(`${this.env.baseUrl + this.api.user}/${this.actRoute.snapshot.paramMap.get('uid') + this.api.createUser}`, this._common.JSON_to_formData(req)).subscribe(
      (res) => {
        if (res.status == true) {
          this._message.succmessage(res?.data?.message);
          this._common.back();
        } else {
          if (res.error.code == 1003) {
            this._common.checkForForceChangePassword(res);
          } else {
            let msg = res?.data?.message != '' ? res?.data?.message : res?.error?.message
            this._message.errmessage(msg);
          }
        }
        this.submit = false
        this.resData = res?.data;

      },
      (err) => {
        console.log(err);
      });
    this.subs.push(sub2)
  }

  cancel() {
    this._common.back();
  }

  trackByIndex(index: number, obj: any): any {
    return index;
  }

  ngDoCheck() {
    if (this.uId != this.actRoute.snapshot.paramMap.get('uid') || this.key != this.actRoute.snapshot.paramMap.get('key')) {
      this.uId = this.actRoute.snapshot.paramMap.get('uid');
      this.key = this.actRoute.snapshot.paramMap.get('key');
      this.getData();
    }

  }

  ngOnDestroy() {
    this.subs.forEach((s) => s.unsubscribe());
  }

}



